import axios from "@/utils/axios.js";

export async function getMoneyAndAwardData(agentId) {
  return axios.get(`/commAgent/moneyAndAwardData/${agentId}`);
}
